export default __webpack_public_path__ + "static/media/feat_caixa.1086dc03.jpg";